import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { Fragment, PropsWithChildren } from "react";

import { Headline } from "@fronterahealth/frontera-ui-components";

interface AssessmentSlideOverProps extends PropsWithChildren {
  open: boolean;
  setOpen: (bool: boolean) => void;
  title: string;
}

export const AssessmentSlideOver: React.FC<AssessmentSlideOverProps> = ({ open, setOpen, children, title }) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <div className="fixed top-0 right-2 z-50">
        <div className="flex max-w-full">
          <Transition.Child
            as={Fragment}
            enter="transform transition ease-in-out duration-500 sm:duration-700"
            enterFrom="translate-x-[1000px]"
            enterTo="translate-x-0"
            leave="transform transition ease-in-out duration-500 sm:duration-700"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-[1000px]"
          >
            <div className="flex flex-col overflow-y-scroll bg-white pt-6 shadow-xl rounded-2xl">
              <div className="px-4 sm:px-6 pb-4">
                <div className="flex items-start justify-between">
                  <Headline size="medium">{title}</Headline>
                  <div className="ml-3 flex h-7 items-center">
                    <button
                      type="button"
                      className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => setOpen(false)}
                    >
                      <span className="absolute -inset-2.5" />
                      <span className="sr-only">Close panel</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="relative">{children}</div>
            </div>
          </Transition.Child>
        </div>
      </div>
    </Transition.Root>
  );
};
